import { ClassValue } from 'clsx'
import React from 'react'
import { Flex, Spin, Typography } from 'antd'
import { cn } from '@/utils/style.ts'
import { CalendarOutlined, EnvironmentOutlined, MailOutlined, StopOutlined, TeamOutlined } from '@ant-design/icons'
import { Link } from 'react-router'
import { useEmployeePublicInfo } from '@/common/hooks/useEmployeePublicInfo.tsx'
import { routes } from '@/utils/routes.ts'
import { EmploymentStatus } from '@/common/types/employment.def.ts'

type EmployeeCardProps = {
  employeeId: string
  className?: ClassValue
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

export const EmployeeCard: React.FC<EmployeeCardProps> = ({ employeeId, className, onClick }) => {
  const { getEmployeePublicInfo, isFetching } = useEmployeePublicInfo()

  if (isFetching) return <Spin />

  const data = getEmployeePublicInfo(employeeId)

  return (
    <Flex vertical gap="small" className={cn('p-2 border rounded-lg', className)} onClick={onClick}>
      {isFetching ? <Spin /> :
        data ?
          <>
            <Link to={routes.employeeData(data.employeeId)} target="_blank">
              <Typography.Text className="text-sm text-link font-semibold">
                {data.employeeId} - {data.displayName}
                {data.status === EmploymentStatus.Inactive && (
                  <StopOutlined className="ml-1 text-xs text-gray-500" title="Inactive" />
                )}
              </Typography.Text>
            </Link>
            <Typography.Text className="text-xs">{data.title}</Typography.Text>
            <Typography.Text className="text-xs">
              <TeamOutlined /> {data.department}
            </Typography.Text>
            <Typography.Text className="text-xs">
              <MailOutlined /> {data.companyEmail}
            </Typography.Text>
            <Typography.Text className="text-xs">
              <EnvironmentOutlined /> {data.country}
            </Typography.Text>
            <Typography.Text className="text-xs">
              <CalendarOutlined /> Joined at {data.joinDate}
            </Typography.Text>
          </>
          : <Typography.Text>Not Found</Typography.Text>
      }
    </Flex>
  )
}